if (!customElements.get('far-selection-summary')) {
  customElements.define('far-selection-summary', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-far-main-variants]').textContent);
      this.fr = this.dataset.locale.startsWith('fr');
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency', currency:this.dataset.currency || 'CAD'});
      this.onInput = event => {
        if (event.target.matches('[data-far-addon-quantity], [name="quantity"]')) {
          const field = event.target;
          const value = Number(field.value);
          field.value = Number.isFinite(value) ? Math.min(Number(field.max), Math.max(Number(field.min), Math.floor(value))) : 0;
        }
        this.update();
      };
      this.onVariant = event => {
        if (event.target.closest('.far-new-product') === this.closest('.far-new-product')) {
          this.mainId = String(event.detail?.variant?.id || '');
          this.update();
        }
      };
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('change', this.onInput);
      document.addEventListener('on:variant:change', this.onVariant);
      const seen = new Set();
      this.form.querySelectorAll('[data-far-addon-quantity]').forEach(field => {
        if (seen.has(field.dataset.farAddonVariant)) {
          field.closest('[data-far-category-choice]').remove();
        } else seen.add(field.dataset.farAddonVariant);
      });
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('input', this.onInput);
      this.form?.removeEventListener('change', this.onInput);
      document.removeEventListener('on:variant:change', this.onVariant);
    }
    update() {
      const list = this.querySelector('[data-far-summary-lines]');
      list.replaceChildren();
      const mainId = this.mainId || this.form.querySelector('[name="id"]').value;
      const main = this.variants.find(variant => String(variant.id) === String(mainId));
      this.form.querySelectorAll('[data-far-extra-main-variants] [data-far-addon-quantity]').forEach(field => {
        const current = String(field.dataset.farAddonVariant) === String(mainId);
        field.disabled = current;
        field.closest('[data-far-category-choice]').hidden = current;
        if (current) field.value = 0;
      });
      let total = 0, pounds = 0, kilograms = 0;
      const addWeight = (title, quantity, multiplier = 1) => {
        const weight = title.replace(',', '.').match(/(\d+(?:\.\d+)?)\s*(?:lbs?|livres|kg)\b/i);
        if (!weight) return;
        if (/kg/i.test(weight[0])) kilograms += Number(weight[1]) * quantity * multiplier;
        else pounds += Number(weight[1]) * quantity * multiplier;
      };
      const line = (title, quantity, cents, field) => {
        const row = document.createElement('div');
        row.className = 'far-selection-summary__line';
        const text = document.createElement('span');
        text.textContent = quantity + ' × ' + title;
        if (field) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = this.fr ? 'Retirer' : 'Remove';
          remove.addEventListener('click', () => {field.value = 0; this.update();});
          text.append(remove);
        }
        const price = document.createElement('strong');
        price.textContent = this.money.format(cents * quantity / 100);
        row.append(text, price);
        list.append(row);
        total += cents * quantity;
      };
      if (main) {
        const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value) || 1);
        let title = this.querySelector('[data-far-main-title]').textContent;
        if (main.title !== 'Default Title') title += ' — ' + main.title;
        line(title, quantity, main.price);
        if (this.dataset.mainPlate === 'true') addWeight(main.title, quantity);
      }
      const selected = [...this.form.querySelectorAll('[data-far-addon-quantity]')].filter(field => Number(field.value) > 0);
      const includesStand = selected.some(field => field.dataset.farIncludesStand === 'true');
      this.form.querySelectorAll('[data-far-category="dumbbell_storage"]').forEach(track => {
        track.closest('.far-category').hidden = includesStand;
        if (includesStand) track.querySelectorAll('[data-far-addon-quantity]').forEach(field => {field.value = 0;});
      });
      const selectedHexWeights = selected.filter(field => field.closest('[data-far-category-choice]').dataset.farProduct === '10301144105265').map(field => Number.parseFloat(field.dataset.farVariantTitle));
      if (this.form.querySelector('[data-far-extra-main-variants] [data-far-product="10301144105265"]') && main) selectedHexWeights.push(Number.parseFloat(main.title));
      const maxHexWeight = Math.max(0, ...selectedHexWeights.filter(Number.isFinite));
      this.form.querySelectorAll('[data-far-storage-max]').forEach(card => {
        const limit = Number(card.dataset.farStorageMax);
        if (!limit) return;
        card.hidden = maxHexWeight > limit;
        if (card.hidden) card.querySelector('[data-far-addon-quantity]').value = 0;
      });
      this.form.querySelectorAll('[data-far-addon-quantity]').forEach(field => {
        const quantity = Math.max(0, Number(field.value) || 0);
        const card = field.closest('[data-far-category-choice]');
        card.classList.toggle('is-selected', quantity > 0);
        if (!quantity || field.disabled) return;
        let title = field.dataset.farTitle;
        if (field.dataset.farVariantTitle.trim()) title += ' — ' + field.dataset.farVariantTitle.trim();
        const unit = card.querySelector('[data-far-sale-unit]');
        if (unit) title += ' (' + unit.textContent.trim() + ')';
        line(title, quantity, Number(field.dataset.farPrice), field);
        if (field.dataset.farPlate === 'true') {
          addWeight(field.dataset.farVariantTitle || field.dataset.farTitle, quantity, unit?.dataset.farSaleUnit === 'pair' ? 2 : 1);
        }
      });
      const weightLine = this.querySelector('[data-far-plate-total]');
      weightLine.hidden = !pounds && !kilograms;
      weightLine.textContent = (this.fr ? 'Poids total des plaques : ' : 'Total selected plate weight: ') + [pounds ? pounds + ' lb' : '', kilograms ? kilograms + ' kg' : ''].filter(Boolean).join(' + ');
      this.querySelector('[data-far-summary-total]').textContent = this.money.format(total / 100);
      this.form.querySelectorAll('.far-category').forEach(category => {
        if (!category.querySelector('[data-far-addon-quantity]')) category.hidden = true;
      });
    }
  });
}
